import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";

type DeleteRequest = {
  endpoint: string;
};

type DeleteResponse = {
  message: string;
  data: object;
};

async function deleteItems(request: DeleteRequest): Promise<DeleteResponse> {
  const response = await httpRequest.delete<DeleteResponse>(request.endpoint);
  return response.data;
}

export function useDeleteMutation(endpoint: string, queryKey?: string) {
  const endpointWithoutSlash = endpoint.replace(/\//g, "");
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteItems,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${queryKey ? queryKey : endpointWithoutSlash}`],
      });
    },
  });
}
